import { otherApiClient } from "./index";
export const BrandCategorySortType = {
    NEW: "최신순",
    DATATYPE: "자료명순"
};
export const FilterKey = {
    RELATEDBOOKS: "relatedBooks",
    UNITS: "units",
    DATATYPES: "dataTypes",
    TICKETS: "tickets",
    SUBJECT: "subject"
};
export const getBrand = async (name, token)=>{
    const headers = {
        Authorization: token
    };
    const { data  } = await otherApiClient.market("/brands/".concat(name), {
        headers
    });
    return data;
};
export const postSubscribeBrand = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market.post("/brands/".concat(name, "/subscribe"), rest);
    return data;
};
export const getBrandCount = async (param)=>{
    let { name  } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/search/count"));
    return data;
};
export const getBrandCategory = async (name)=>{
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/categories"));
    return data;
};
export const getBrandCategoryId = async (param)=>{
    let { name , categoryId , ...rest } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/categories/").concat(categoryId), {
        params: {
            ...rest
        }
    });
    return data;
};
export const getBrandSearch = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/search"), {
        params: {
            ...rest
        }
    });
    return data;
};
export const getBrandSearchFilter = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/search/filter"), {
        params: {
            ...rest
        }
    });
    return data;
};
// 공지 게시글 이미지 업로드
export const postNoticeImageUpload = async (param)=>{
    let { name , postType , formData  } = param;
    const { data  } = await otherApiClient.market.post("/brands/".concat(name, "/").concat(postType, "/images"), formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return data;
};
// 공지 게시글 업로드
export const postBrandNotice = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market.post("/brands/".concat(name, "/notice"), {
        ...rest
    });
    return data;
};
// 공지 게시글 리스트 조회
export const getBrandNotices = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/notices"), {
        params: {
            ...rest
        }
    });
    return data;
};
// 공지 게시글 상세 조회
export const getBrandNoticeDetail = async (param)=>{
    let { name , postId  } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/notices/").concat(postId));
    return data;
};
// 공지 게시글 삭제
export const deleteBrandNotice = async (param)=>{
    let { name , postId  } = param;
    const { data  } = await otherApiClient.market.delete("/brands/".concat(name, "/notices/").concat(postId));
    return data;
};
// 공지 게시글 수정
export const patchBrandNotice = async (param)=>{
    let { name , postId , ...rest } = param;
    const { data  } = await otherApiClient.market.patch("/brands/".concat(name, "/post/").concat(postId), {
        ...rest
    });
    return data;
};
// QnA 게시글 등록
export const postBrandQnA = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market.post("/brands/".concat(name, "/qna"), {
        ...rest
    });
    return data;
};
// QnA 게시글 상세 조회
export const getQnADetail = async (param)=>{
    let { name , postId  } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/qna/").concat(postId));
    return data;
};
// QnA 게시글 수정
export const patchBrandQnA = async (param)=>{
    let { name , postId , ...rest } = param;
    const { data  } = await otherApiClient.market.patch("/brands/".concat(name, "/post/").concat(postId), {
        ...rest
    });
    return data;
};
// QnA 게시글 공개 비공개 변경
export const patchBrandQnAPrivate = async (param)=>{
    let { name , postId , isPrivate  } = param;
    const { data  } = await otherApiClient.market.patch("/brands/".concat(name, "/post/").concat(postId, "/private"), {
        isPrivate
    });
    return data;
};
// QnA 게시글 리스트 조회
export const getBrandQnA = async (param)=>{
    let { name , ...rest } = param;
    const { data  } = await otherApiClient.market("/brands/".concat(name, "/qna"), {
        params: {
            ...rest
        }
    });
    return data;
};
// 공지 게시글 삭제
export const deleteBrandQnA = async (param)=>{
    let { name , postId  } = param;
    const { data  } = await otherApiClient.market.delete("/brands/".concat(name, "/qna/").concat(postId));
    return data;
};
// 댓글 등록
export const postBrandQnAReply = async (param)=>{
    let { name , postId , ...rest } = param;
    const { data  } = await otherApiClient.market.post("/brands/".concat(name, "/qna/").concat(postId, "/reply"), {
        ...rest
    });
    return data;
};
// 댓글 삭제
export const deleteBrandQnAReply = async (param)=>{
    let { name , postId , replyId  } = param;
    const { data  } = await otherApiClient.market.delete("/brands/".concat(name, "/qna/").concat(postId, "/replies/").concat(replyId));
    return data;
};
// 댓글 수정
export const patchBrandQnAReply = async (param)=>{
    let { name , postId , replyId , ...rest } = param;
    const { data  } = await otherApiClient.market.patch("/brands/".concat(name, "/qna/").concat(postId, "/replies/").concat(replyId), {
        ...rest
    });
    return data;
};
